export default __webpack_public_path__ + "static/media/mail.ca872002.svg";